import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

import { palette } from "../../theme/palette";
import { driverTabs } from "../../consts/tabs";

import { getDriversExtract } from "../../utils/driverExtract";

import { hasFiltersEnabledSelector } from "../../reducers/filters/selectors";
import { resetFilter } from "../../reducers/filters";
import {
  getSelectedDepot,
  selectedTabSelector,
} from "../../reducers/ownApp/selectors";
import {
  driverEditModeSelector,
  driverProfilesSelector,
  matrixDaysSelector,
} from "../../reducers/driverManagement/selectors";

import { View } from "../Base";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "30px",
  },
  button: {
    backgroundColor: palette.sunburst,
    fontSize: "11px",
    height: "17px",
    width: "95px",
    "&:hover": {
      backgroundColor: palette.sunburst,
      opacity: 0.6,
    },
    marginRight: "4px",
  },
  buttonDisabled: {
    backgroundColor: palette.typography.white.disabled,
  },
  textContainer: {
    marginLeft: "4px",
    flex: 1,
  },
  text: {
    color: palette.white,
    fontSize: "14px",
    fontWeight: "500",
  },
  smallerText: {
    marginTop: "2px",
    color: palette.white,
    fontSize: "12px",
    fontWeight: "500",
  },
  anchor: {
    display: "none",
  },
});

export const DriverExtractBar = ({ drivers }) => {
  const styles = useStyles();
  const downloadRef = useRef();
  const dispatch = useDispatch();
  const [{ url, fileName }, setDownload] = useState({});
  const selectedDepot = useSelector(getSelectedDepot);
  const selectedTab = useSelector(selectedTabSelector);
  const matrixDays = useSelector(matrixDaysSelector);
  const allDrivers = useSelector(driverProfilesSelector);
  const hasFiltersEnabled = useSelector(hasFiltersEnabledSelector);
  const driverEditMode = useSelector(driverEditModeSelector);
  const disable = !hasFiltersEnabled || driverEditMode;
  const allDriversLength = Object.keys(allDrivers).length;

  useEffect(() => {
    if (!url || !downloadRef?.current) return;
    downloadRef.current.click();
    URL.revokeObjectURL(url);
    setDownload({});
  }, [url]);

  const onExtractClick = () => {
    if (url) return;
    else setDownload(getDriversExtract(drivers, selectedDepot, matrixDays));
  };

  return selectedDepot && allDriversLength ? (
    <View className={styles.container}>
      <View className={styles.textContainer}>
        <Typography
          className={
            selectedTab === driverTabs[0].label
              ? styles.smallerText
              : styles.text
          }
        >
          {`Drivers ${drivers.length || 0} / ${allDriversLength}`}
        </Typography>
      </View>
      <Button className={styles.button} onClick={onExtractClick}>
        Extract CSV
      </Button>
      <Button
        className={clsx(styles.button, disable && styles.buttonDisabled)}
        onClick={() => dispatch(resetFilter())}
        disabled={driverEditMode}
      >
        Clear Filters
      </Button>
      <a
        className={styles.anchor}
        ref={downloadRef}
        download={fileName}
        href={url}
      >
        Download Driver Extract
      </a>
    </View>
  ) : null;
};
